import React from 'react';
import {BreadcrumbItems} from '../dummy_data/localizationItems.json'

const Breadcrumb = ({location}) => {
	// const locationName = location.newsType === "Enterprise"? "企业新闻" : "行业动态";
	// console.log(this.props);
	return (
		<div className="breadcrumb">
			<ul>
				<li>
					<a href="#/">{localStorage.getItem("isEnglish") === "true"? BreadcrumbItems.find(i => i.fieldName === "OWM").eName : BreadcrumbItems.find(i => i.fieldName === "OWM").name}</a>
				</li>
				{
					location.map((item, i) => {
						return(
							<li key={i}>
								<span>&gt;</span>
								<a href={'#' + item.url}>{item.name}</a> 
							</li>
						);
					})
				}
			</ul>
		</div>
	)
}

export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js